import React, { useState } from 'react'
import { Modal, Form, Input, Spin, App, Space } from 'antd';
import Icon from '../../cpn/Icon';
import { useTDtongyiMutation, useTDbohuiMutation } from '../../store/DianShangYeWuApi';

function ReportCheckNodeApprove(props) {
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [openReject, setOpenReject] = useState(false);
    const [form] = Form.useForm();
    const [formReject] = Form.useForm();
    const [updateIsFetching, setUpdateIsFetching] = useState(false);
    const [updateIsFetchingReject, setUpdateIsFetchingReject] = useState(false);
    const [tongyi] = useTDtongyiMutation();
    const [bohui] = useTDbohuiMutation();
    return (
        <>
            <Space orientation='vertical'>
                <Space>{props.yh_name}</Space>
                <Space>
                    <Icon type="approve"  onClick={() => {setOpen(true);}}/>
                    <Icon type="reject"  onClick={() => {setOpenReject(true);}}/>
                </Space>
            </Space>
            <Modal 
                open={open} 
                onCancel={() => {
                    setOpen(false);
                    setUpdateIsFetching(false);
                }} 
                footer={null}
                title={<span style={{color: 'green'}}>确认同意审批？单据将流转到下一审批人。</span>}
            >
                <Spin spinning={updateIsFetching} tip="同意中...">
                    <Form
                        form={form}
                        name={`form_report_${props.dsbzd_sp_id}`}
                        initialValues={{dsbzd_sp_content: '',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            tongyi({
                                'dsbzd_sp_id': props.dsbzd_sp_id,
                                'dsbzd_id': props.dsbzd_id,
                                'dsbzd_sp_yh_id': props.dsbzd_sp_yh_id,
                                'dsbzd_sp_content': value.dsbzd_sp_content
                            }).then((res) => {
                                if(res.data.Status === 'success'){
                                    setOpen(false);
                                    message.success('审批成功');
                                }else{
                                    message.error('审批失败'+res.data.Message);
                                }
                            });
                        }}
                    >
                        <Form.Item label="团队名称">
                            <span>{props.dsbzd_name}</span>
                        </Form.Item>
                        <Form.Item name="dsbzd_sp_content" label="说明">
                            <Input.TextArea rows={4} placeholder='选填'/>
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                            <Icon type="submit"  onClick={() => {
                                setUpdateIsFetching(true);
                                form.submit();
                            }}/>
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
            <Modal 
                open={openReject} 
                onCancel={() => {
                    setOpenReject(false);
                    setUpdateIsFetchingReject(false);
                }} 
                footer={null}
                title={<span style={{color: 'red'}}>确认驳回单据？单据将退回给提交人。</span>}
            >
                <Spin spinning={updateIsFetchingReject} tip="驳回中...">
                    <Form
                        form={formReject}
                        name={`form_report_reject_${props.dsbzd_sp_id}`}
                        initialValues={{dsbzd_sp_content: '',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            bohui({
                                'dsbzd_sp_id': props.dsbzd_sp_id,
                                'dsbzd_id': props.dsbzd_id,
                                'dsbzd_sp_yh_id': props.dsbzd_sp_yh_id,
                                'dsbzd_sp_content': value.dsbzd_sp_content
                            }).then((res) => {
                                if(res.data.Status === 'success'){
                                    setOpenReject(false);
                                    message.success('驳回成功');
                                }else{
                                    message.error('驳回失败'+res.data.Message);
                                }
                            });
                        }}
                    >
                        <Form.Item label="团队名称">
                            <span>{props.dsbzd_name}</span>
                        </Form.Item>
                        <Form.Item name="dsbzd_sp_content" label="说明">
                            <Input.TextArea rows={4} placeholder='选填'/>
                        </Form.Item>
                        <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                            <Icon type="submit"  onClick={() => {
                                setUpdateIsFetchingReject(true);
                                formReject.submit();
                            }}/>
                        </Form.Item>
                    </Form>
                </Spin>
            </Modal>
        </>
    )
}

export default ReportCheckNodeApprove
